import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿El contenido está en español?',
    a: 'Sí. Todo el material está en español.'
  }, {
    q: '¿Cómo recibo el acceso?',
    a: 'Recibirás acceso inmediato después de completar el pago.'
  }, {
    q: '¿Puedo usarlo desde el celular?',
    a: 'Sí. Podés escuchar o leer desde cualquier dispositivo.'
  }, {
    q: '¿Es un pago único?',
    a: 'Sí. Pagás una sola vez y tenés acceso de por vida.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 px-4 bg-[#111827]" data-id="element-94">
      <div className="max-w-3xl mx-auto" data-id="element-95">
        <h2 className="text-3xl md:text-4xl font-black text-center mb-8 text-white" data-id="element-96">
          Preguntas frecuentes
        </h2>

        <div className="space-y-3" data-id="element-97">
          {faqs.map((faq, idx) => <div key={idx} className="border border-gray-700 rounded-lg overflow-hidden bg-gray-800" data-id="element-98">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full flex items-center justify-between p-4 text-left focus:outline-none" data-id="element-99">
                <span className="text-lg font-bold text-white" data-id="element-100">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`} data-id="element-101" />
              </button>

              <AnimatePresence data-id="element-102">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-103">
                    <div className="p-4 pt-0 text-base text-gray-300 font-medium border-t border-gray-700" data-id="element-104">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}